import { render, staticRenderFns } from "./RedeemingSalesDetails.vue?vue&type=template&id=118a09ec&scoped=true&"
import script from "./RedeemingSalesDetails.vue?vue&type=script&lang=js&"
export * from "./RedeemingSalesDetails.vue?vue&type=script&lang=js&"
import style0 from "./RedeemingSalesDetails.vue?vue&type=style&index=0&id=118a09ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a09ec",
  null
  
)

export default component.exports